<script setup>
import emitter from "@/utils/bus"; // 通信对象
import { ref, computed, onUnmounted, onMounted } from "vue";
import { useConfigStore } from "@/store/config";
import { useUserStore } from "@/store/user";
import { useI18n } from "vue-i18n";
const { t } = useI18n();

import { formatTimestamp, truncateString, appHapticFeedback, addressFun, addCommasToNumber } from "@/utils/common";
const config = useConfigStore();
const userStore = useUserStore();
const isShow = ref(false);
const web_withdraw_record = computed(() => userStore.web_withdraw_record);
const props = defineProps({
  detail: {
    type: Object,
    default: {},
  },
});
const formattedAddress = computed(() => {
  if (!userStore.ton_address) return "";
  const address = addressFun(userStore.ton_address);
  // const address = userStore.ton_address;
  if (address.length <= 10) return address;
  return address.slice(0, 4) + "*****" + address.slice(-4);
});

emitter.on("showWithdrawDetail", (res) => {
  isShow.value = res;
});

const emit = defineEmits(["start"]);
let shareOnClick = async () => {
  console.log(props.detail, "=======>", props);
};
let close = () => {
  isShow.value = false;
  appHapticFeedback();
};
onUnmounted(() => {
  emitter.emit("showWithdrawDetail", false);

});

let acceleratedOnClick = () => {
  appHapticFeedback();
  emitter.emit("acceleratedWithdrawals", props.detail);
  close();
};
let button_style = (id) => {
  if (id == web_withdraw_record.value[web_withdraw_record.value.length - 1].id && config.withdraw_ladder[0].payment) {
    return {
      display: "none",
    };
  }
  return {
    backgroundColor: config.themes_color,
  }
};
</script>

<template>
  <div class="view" v-show="isShow">
    <div class="language">
      <div class="top">
        <div class="top_title">{{ $t("message.Withdrawal") }}</div>
        <div class="close" @click="close">
          <img src="@/assets/icon/close.svg" alt="" />
        </div>
      </div>
      <div class="detail">
        <div class="detail-item">
          <div class="name">
            {{ $t("message.Receivingwallet") }}
          </div>
          <div class="value">{{ formattedAddress }}</div>
        </div>

        <div class="detail-item">
          <div class="name">
            {{ $t("message.Amount") }}
          </div>
          <div class="value">
            {{ addCommasToNumber(props.detail.send_amount) }}
            {{ config.coin_name }}
          </div>
        </div>

        <div class="detail-item">
          <div class="name">
            {{ $t("message.Networkfee") }}
          </div>
          <div class="value">{{ addCommasToNumber(config.withdraw_fee) }} {{ config.coin_name }}</div>
        </div>

        <div class="detail-item">
          <div class="name" @click="shareOnClick">
            {{ $t("message.WithdrawStatus") }}
          </div>
          <div>
            <div class="value"
              v-if="props.detail.audit_status == 1 || props.detail.audit_status == 7 || props.detail.audit_status == 9 || props.detail.audit_status == 11">
              {{ $t("message.Processing") }}
            </div>
            <div class="value"
              v-if="props.detail.audit_status == 2 || props.detail.audit_status == 8 || props.detail.audit_status == 10">
              {{ $t("message.Success") }}
            </div>
            <div class="value" v-if="props.detail.audit_status == 3">
              {{ $t("message.Rejection") }}
            </div>
          </div>
        </div>

        <div class="detail-item">
          <div class="name">
            {{ $t("message.Submissiontime") }}
          </div>
          <div class="value">{{ formatTimestamp(props.detail.created_at) }}</div>
        </div>
      </div>
      <div class="detail-tip" @click="acceleratedOnClick" :style="button_style(props.detail.id)"
        v-if="props.detail.audit_status == 1 || props.detail.audit_status == 7 || props.detail.audit_status == 9">
        {{ $t("message.Accelerated") }} 🚀
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use "@/styles/surfaces" as surface;

.view {
  @include surface.dialog-overlay;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  backdrop-filter: blur(5px);

  .detail-tip {
    @include surface.press-feedback;
    font-size: 14px;
    padding: 8px;
    border-radius: 12px;
    margin: 8px 0;
    background-color: #2a2a2a;
    color: #ffffff;
    margin-top: 8px;
    margin-bottom: 0;
    text-align: center;
  }

  .detail {
    margin: 8px 0 0;
    margin-top: 8px;
    margin-bottom: 0;
  }

  .detail-item {
    gap: 8px;
    margin-top: 6px;
    padding: 0;
    align-items: start;
    font-size: 14px;
    overflow-wrap: anywhere;
    display: flex;
    justify-content: space-between;

    .name {
      color: #888888;
      display: flex;
      align-items: center;
      font-weight: normal;

      .profit-icon {
        width: 4.5vw;
        height: 4.5vw;
        margin-left: 1vw;
      }
    }

    .themes-color {
      color: v-bind("config.themes_color");
      font-weight: bold;
    }

    .value {
      color: #ffffff;
      font-weight: bold;
    }
  }

  .language {
    @include surface.dialog-panel;
    background: #1e1e1e;
    display: block;
    border: #2d2d2d solid 1px;

    .content {
      margin-top: 8px;
      margin-bottom: 8px;
      font-size: 14px;
      line-height: 1.6;
      //overflow-y: auto;
      //height: 38vh;
      color: #1f1f1f;
      white-space: pre-wrap;
      //text-align: center;
    }

    .friends-num {
      text-align: center;
      font-size: 3.5vw;
      color: v-bind("config.themes_color");
    }

    .partner {
      margin-bottom: 5vw;
      text-align: center;

      .partner-title {
        text-align: center;
        font-size: 3.5vw;
        font-weight: bold;
      }

      .partner-image {
        margin-top: 2vw;
        width: 76vw;
      }
    }

    .button {
      @include surface.button;
      margin-top: 8px;
      width: 100%;
      text-align: center;
      font-weight: bold;
      color: white;
    }

    .top {
      @include surface.dialog-header;
      .close {
        @include surface.close-button;
        background-color: rgba(255, 255, 255, 0.1);

        img {
          width: 100%;
          height: 100%;
        }
      }

      &_title {
        @include surface.title;
        width: auto;
        font-weight: bold;
        color: #ffffff;
      }

      &_introduced {
        color: #1f1f1f;
        font-size: 4vw;
      }
    }
  }
}
.view .language .top .close img {
  width: 24px;
  height: 24px;
}
</style>
